import { useState } from 'react';

import { Outlet } from 'react-router-dom';

import { ELocalStorageKeys } from 'constants/enums';
import AcSidebar from 'design-system/AcSidebar';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';
import { localStorageUtil } from 'utils/localStorageUtil';

import { SendAgreementModal } from 'components/SendContractModal/Index';
import { SidebarProvider } from 'components/ui/sidebar';
import { VerifyBusinessModal } from 'components/VerifyBusinessModal/Index';

import { Header } from './Header';
import { SetupChecklistContainer } from './SetupChecklist/Container';
import { WipBanner } from './WipBanner';

export const Layout: React.FC = () => {
  const { isChecklistEnabled } = useChecklistState();
  const [showBanner, setShowBanner] = useState(() => {
    const savedState = localStorageUtil.get(
      ELocalStorageKeys.WIP_BANNER_CLOSED
    );
    return savedState === null;
  });

  const handleCloseBanner = () => {
    setShowBanner(false);
    localStorageUtil.set(ELocalStorageKeys.WIP_BANNER_CLOSED, 'true');
  };

  return (
    <SidebarProvider>
      <AcSidebar />
      <div className="flex flex-col h-full w-full overflow-hidden">
        <Header />
        <main className="overflow-auto">
          <Outlet />
        </main>
        {showBanner && !isChecklistEnabled && (
          <WipBanner onCloseIconClick={handleCloseBanner} />
        )}
        {isChecklistEnabled && (
          <>
            <SetupChecklistContainer />
            <VerifyBusinessModal />
            <SendAgreementModal />
          </>
        )}
      </div>
    </SidebarProvider>
  );
};
